<app-chart [title]="title" [tooltip]="tooltip">
  @if (noData) {
    <div class="no-data-container">
      <div class="no-data-message">{{ 'common.noData' | labelsProvider }}</div>
    </div>
  } @else {
    <div class="runtime-risk-chart-container">
      <div class="chart-wrapper">
        <canvas baseChart [data]="chartData" [options]="chartOptions" [type]="'bar'"> </canvas>
      </div>
    </div>
  }
</app-chart>
